<script>
  import { Link } from "svelte-routing";
  import { onMount } from "svelte";
  import emailjs from "@emailjs/browser";

  // Contact form state
  let firstName = "";
  let lastName = "";
  let company = "";
  let email = "";
  let phone = "";
  let helpOption = "";
  let message = "";
  let submitting = false;
  let submitStatus = "";

  async function handleSubmit() {
    submitting = true;
    submitStatus = "";

    const payload = {
      title: "Free Consultation Request",
      to_email: "craft2code743@gmail.com",
      name: firstName + " " + lastName,
      from_name: firstName + " " + lastName,
      email: email,
      from_email: email,
      company: company,
      phone: phone,
      help_option: helpOption,
      message: message,
    };

    try {
      const response = await emailjs.send(
        "service_3137pxo",
        "template_kxc76ui",
        payload
      );
      console.log("✅ Email sent successfully!", response.status, response.text);
      submitStatus = "success";
      firstName = ""; lastName = ""; company = ""; email = "";
      phone = ""; helpOption = ""; message = "";
    } catch (err) {
      console.error("❌ EmailJS failed to send email.", err);
      submitStatus = "error";
    }
    submitting = false;
  }

  onMount(() => {
    emailjs.init("fHRZE2qnPN5GaQpnY");
  });
</script>

<svelte:head>
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
  />
  <link
    href="https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap"
    rel="stylesheet"
  />
</svelte:head>

<div class="moapp1">
  <img src="/img/24.jpg" alt="Mobile Development" class="background-image" />
  <div class="text-overlay">Mobile Development</div>
</div>

<div class="moapp2">
  <h1 class="title">Mobile App Development</h1>
  <div class="content">
    <div class="section left">
      <h2><i class="fas fa-rocket"></i> High-Performance Apps</h2>
      <p>
        We build high-performance mobile apps<br /> for iOS and Android that engage users<br /> and support business goals.
      </p>
      <h2><i class="fas fa-paint-brush"></i> Seamless UX & UI</h2>
      <p>
        We design seamless user experiences<br /> that combine functionality, speed,<br /> and visual appeal.
      </p>
      <h2><i class="fas fa-users"></i> Engage Your Audience</h2>
      <p>
        We help businesses reach their customers<br /> on mobile, increasing engagement<br /> and retention.
      </p>
    </div>
    <div class="section center">
      <img src="/img/25.png" alt="Center Image" class="center-image" />
    </div>
    <div class="section right">
      <h2><i class="fas fa-expand-arrows-alt"></i> Scalable & Secure</h2>
      <p>
        We ensure scalable, secure solutions<br /> that integrate with your existing systems<br /> and support future growth.
      </p>
      <h2><i class="fas fa-headset"></i> End-to-End Support</h2>
      <p>
        We provide end-to-end support,<br /> from concept and design to launch<br /> and post-release maintenance.
      </p>
    </div>
  </div>
</div>

<!-- <div class="moapp3">
  <div class="quarter">
    <img src="/img/mobp.png" alt="First Image" class="quarter-image" />
  </div>
  <div class="quarter">
    <p class="large-text">15+</p>
    <h3>Countries<br /> Worldwide</h3>
    <p>
      To succeed, every<br /> software solution must be<br /> deeply integrated
      into the<br /> existing tech <br />environment...
    </p>
  </div>
  <div class="quarter">
    <img src="/img/mobp.png" alt="Third Image" class="quarter-image" />
  </div>
  <div class="quarter">
    <p class="large-text">2k</p>
    <h3>Happy <br />Customers</h3>
    <p>
      To succeed, every<br /> software solution must be<br /> deeply integrated
      into the<br /> existing tech <br />environment...
    </p>
  </div>
</div> -->

<div class="moapp4">
  <div class="leftmo4">
    <img src="/img/26.jpg" alt="Partner Image" class="partner-image" />
  </div>
  <div class="rightmo4">
    <h2>Your Partner for<br /> Mobile Innovation</h2>
    <p class="main-text">
      We help businesses bring their ideas to life with custom mobile app
      development, from concept and design to deployment and post-launch
      support. Our team ensures every app is user-friendly, scalable, and
      secure, tailored to your business goals.
    </p>
  </div>
</div>

<div class="moapp5">
  <div class="title-container">
    <h2 class="title">Industries We Serve</h2>
  </div>
  <div class="industry-container">
    <div class="industry">
      <h3 class="industry-title">Gaming &<br /> Entertainment</h3>
      <p class="industry-text">
        Engaging apps and interactive<br /> experiences that captivate users.
      </p>
    </div>
    <div class="industry">
      <h3 class="industry-title">Business &<br /> Productivity</h3>
      <p class="industry-text">
        Mobile solutions that streamline<br /> workflows and boost efficiency.
      </p>
    </div>
    <div class="industry">
      <h3 class="industry-title">E-commerce &<br /> Retail</h3>
      <p class="industry-text">
        Apps designed to enhance customer<br /> engagement and drive sales.
      </p>
    </div>
  </div>
</div>

<div class="cont">
  <div class="leftco">
    <!-- <div class="top-left-text1">Contact Us</div> -->
    <div class="bottom-left-textc">
      Partner with us <br /> for development
    </div>
    <div class="left-text">
      We’re happy to answer any questions you may have and help<br /> you determine
      which of our services best fit your needs.
    </div>
    <div class="left-text">Call us at: 76 361 951</div>
    <div class="left-text">Your benefits:</div>
    <div class="benefits-container">
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Client-oriented
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Independent
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Competent
        </div>
      </div>
      <div class="benefits">
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Results-driven
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Problem-solving
        </div>
        <div class="benefit">
          <i class="fas fa-check-circle"></i>
          Transparent
        </div>
      </div>
    </div>
    <div class="left-text">What happens next?</div>
    <div class="steps">
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We Schedule a call at<br /> your convenience
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We do a discovery <br />and consulting meting
      </div>
      <div class="step">
        <i class="fas fa-arrow-right"></i>
        We prepare a<br /> proposal
      </div>
    </div>
  </div>
  <div class="rightco">
    <div class="contact-form-container">
      <h2 style="text-align: center;">Schedule a Free Consultation</h2>
      <div class="contact-form">
        <div class="form-group">
          <div class="name-inputs">
            <input
              type="text"
              id="firstName"
              name="firstName"
              placeholder="First Name"
              bind:value={firstName}
              required
            />
            <input
              type="text"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
              bind:value={lastName}
              required
            />
          </div>
        </div>
        <div class="form-group">
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Company/Organization"
            bind:value={company}
          />
        </div>
        <div class="form-group">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Company Email"
            bind:value={email}
            required
          />
        </div>
        <div class="form-group">
          <input type="text" id="phone" name="phone" placeholder="Phone" bind:value={phone} />
        </div>
        <div class="form-group">
          <select id="helpOption" name="helpOption" bind:value={helpOption}>
            <option value="">How can we help you?</option>
            <option value="Mobile App Development">Mobile App Development</option>
            <option value="Software Development">Software Development</option>
            <option value="Web Development">Web Development</option>
            <option value="Blockchain">Blockchain</option>
            <option value="Game Development">Game Development</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div class="form-group">
          <textarea id="message" name="message" rows="6" placeholder="Message" bind:value={message}
          ></textarea>
        </div>
        {#if submitStatus === "success"}
          <p class="form-success">✅ Message sent successfully! We'll be in touch soon.</p>
        {:else if submitStatus === "error"}
          <p class="form-error">❌ Something went wrong. Please try again or email us at craft2code743@gmail.com</p>
        {/if}
        <button type="button" class="submit-button" disabled={submitting} on:click={handleSubmit}>
          {submitting ? "Sending..." : "Submit"}
        </button>
      </div>
    </div>
  </div>
</div>

<footer class="footer">
  <div class="footer-content">
    <div class="leftfoo">
      <div class="footer-section">
        <div class="links-development">
          <div class="quick-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/home" style="color: black;">Home</Link></li>
              <li><Link to="/service" style="color: black;">Services</Link></li>
              <li><Link to="/about" style="color: black;">About Us</Link></li>
              <li>
                <Link to="/contact" style="color: black;">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div class="development">
            <h4>Development</h4>
            <ul>
              <li>
                <Link to="/mobileapp" style="color: black;">Mobile App</Link>
              </li>
              <li>
                <Link to="/software" style="color: black;">Web</Link>
              </li>
              <li><Link to="/game" style="color: black;">Game</Link></li>
              <li><Link to="/web" style="color: black;">Software</Link></li>
              <li>
                <Link to="/blockchain" style="color: black;">Blockchain</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>
    <div class="rightfo">
      <div class="image-containerff">
        <img src="/img/34.png" alt="Footer Image" id="footerImage" />
        <div class="text-overlay1">
          <h2 style="transform: scale(0.7);"><img src="/img/logo12.png" /></h2>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="hofo">
  <div class="detail-containerfo">
    <div class="detailfo">
      <p>
        REVIEWED ON
        <span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span><span style="color: red;">★</span
        ><span style="color: red;">★</span>
      </p>
      <p>
        <span style="color: black; font-size: 24px;">CLUTCH</span>
        <span style="color: gray;">31 reviews</span>
      </p>
    </div>
    <!-- <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>God Of Mining</p>
      <p>Lebanon</p>
    </div> -->
    <div class="vertical-linefo"></div>
    <div class="detailfo blue-textfo">
      <p>T: 76 361 951</p>
      <p>E: Info@craft2code.com</p>
    </div>
    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.linkedin.com/company/craft2code" target="_blank">
          <i class="fab fa-linkedin"></i>
        </a>
      </p>
      <p>LinkedIn</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.instagram.com/craft2code/" target="_blank">
          <i class="fab fa-instagram"></i>
        </a>
      </p>
      <p>Instagram</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://www.facebook.com/craft2code" target="_blank">
          <i class="fab fa-facebook"></i>
        </a>
      </p>
      <p>Facebook</p>
    </div>

    <div class="detailfo blue-textfo">
      <p>
        <a href="https://maps.app.goo.gl/wCDPsTqkkNU39Fds6" target="_blank">
          <i class="fas fa-map-marker-alt"></i>
        </a>
      </p>
      <p>Location</p>
    </div>
  </div>
  <div class="center-textfooo">
    <p>© 2024Tecnologia Terms & Conditions Privacy Policy</p>
  </div>
</div>

<style>
  .hofo {
    padding: 20px;
  }

  .detail-containerfo {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .detailfo {
    flex: 1;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .vertical-linefo {
    border-left: 1px solid #ccc;
    margin: 0 10px;
  }

  .detailfo p {
    margin: 0;
    font-size: 0.8rem;
  }

  .detailfo .blue-textfo i {
    font-size: 20px;
    margin-bottom: 5px;
  }

  .stars {
    font-size: 24px;
  }

  .blue-textfo p:first-child {
    margin: 0;
    font-size: 0.8rem;
    color: #dc1f26;
  }

  .blue-textfo p:first-child i {
    margin: 0;
    font-size: 1.2rem;
    color: #dc1f26;
  }

  .blue-textfo p:last-child {
    color: black;
  }

  .hofo {
    border-top: 1px solid #ccc;
    padding: 10px 0;
    margin-top: 20px;
  }

  .center-textfooo {
    text-align: center;
    margin-top: 20px;
  }

  .rightfo .image-containerff {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .rightfo img {
    width: 100%;
    height: 100%; /* Make the image take full height */
    object-fit: cover; /* Ensure the image covers the container */
    transition: transform 0.5s; /* Add transition effect for scaling */
  }

  .rightfo img:hover {
    transform: scale(1.1); /* Increase scale on hover */
  }
  .text-overlay1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 10;
  }

  .text-overlay1 h2,
  .text-overlay1 button {
    margin-top: 20px; /* Add margin to separate the elements */
  }

  .footer {
    margin-top: 30px;
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    justify-content: space-between;
    height: auto; /* Set the footer height to full viewport height */
  }
  .footer-content {
    display: flex;
  }

  .leftfoo {
    height: 100%;
    width: 50%;
  }

  .rightfo {
    width: 50%;
    position: relative;
    display: flex;
    justify-content: center; /* Center content vertically */
    align-items: center; /* Center content horizontally */
    text-align: center;
    height: 100%; /* Ensure it takes full height */
  }

  .leftfoo .footer-section {
    margin-bottom: 20px;
  }

  .rightfo button {
    background-color: #39e9e0;
    color: #333333;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .rightfo h2 {
    color: #333333;
    font-family: BreeSerif;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .leftfoo .footer-section h4 {
    color: #333333;
    font-size: 1.8rem;
    font-family: SourceSans;
    font-weight: bold;
    margin-top: 65px;
  }

  .leftfoo .footer-section ul {
    list-style: none;
    padding-top: 0px;
    margin-top: 0;
  }

  .leftfoo .footer-section ul li {
    padding-top: 10px;
    margin-bottom: 10px;
  }

  .leftfoo .footer-section ul li a {
    color: #333333;
    font-family: SourceSans;
    text-decoration: none;
  }

  .leftfoo .footer-section ul li a:hover {
    color: #dc1f26;
  }

  .leftfoo .footer-section input[type="email"] {
    margin-top: 50px;
    padding: 15px;
    border: none;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-left: 20px;
    background-color: #333333;
    color: white;
    border: 2px solid white; /* Set transparent border by default */
    width: calc(100% - 200px); /* Adjusted width to account for margin */
  }

  .leftfoo .footer-section input[type="checkbox"] {
    margin-top: 15px;
    margin-left: 30px;
    margin-right: 10px;
    transform: scale(1);
  }

  .leftfoo .footer-section .checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    margin-top: 15px;
  }
  .leftfoo .footer-section label {
    padding-right: 200px;
    font-size: 0.8rem; /* Increase font size of the checkbox label */
  }
  .leftfoo .footer-section button {
    background-color: #333333;
    margin-left: 30px;
    margin-top: 40px;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 30px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .leftfoo .footer-section button:hover {
    background-color: #dc1f26;
  }
  .rightfo h2 {
    z-index: 10;
  }

  .rightfo button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .rightfo button::before,
  .rightfo button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .rightfo button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .rightfo button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .rightfo button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .rightfo button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .rightfo button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .links-development {
    display: flex;
  }

  .quick-links,
  .development {
    margin-left: 30px;
    padding-top: 5px;
    flex: 1;
  }

  .quick-links ul,
  .development ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .quick-links h4,
  .development h4 {
    font-size: 1.9rem;
  }

  /* css for contact */
  .cont {
    padding-top: 70px;
    display: flex;
    /* background: linear-gradient(
      to bottom,
      white 0%,
      white 19%,
      #dc1f26 20%,
      red 70%,
      white 71%
    ); */
    /* background: linear-gradient(45deg, #ffffff, #dc1f26, #ffffff); */
    width: 100%;
  }

  .leftco {
    flex: 70%; /* Set the left div to take up 70% of the available space */
    color: #333333;
    padding-left: 120px;
  }

  .left-text {
    padding-top: 50px;
    font-size: 1.3em;
    font-family: BreeSerif;
  }

  .benefits-container {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
  }

  .benefits {
    flex: 1;
    font-family: BreeSerif;
  }

  .benefit {
    padding: 5px 0;
    font-family: SourceSans;
  }

  .benefit i {
    margin-right: 10px;
  }

  .steps {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    font-family: BreeSerif;
  }

  .step {
    padding-bottom: 20px;
    flex: 1;
    font-family: SourceSans;
  }

  .top-left-text1 {
    /* top: 20px; */
    padding-top: 0px;
    margin-top: 0px;
    font-family: SourceSans;

    font-size: 18px;
  }
  .name-inputs {
    display: flex;
  }

  .name-inputs input {
    flex: 1; /* Take up equal space */
    margin-right: 10px; /* Add space between inputs */
  }

  .name-inputs input:last-child {
    margin-right: 0; /* Remove margin from last input */
  }
  .rightco {
    background-color: white;
    /* margin-top: 10px; */
    margin-right: 200px;
    margin-bottom: 30px;
    flex: 50%; /* Set the right div to take up 30% of the available space */
  }

  .contact-form-container {
    display: flex;
    flex-direction: column; /* Align items vertically */
    align-items: center; /* Center items horizontally */
    padding-right: 20px;
  }

  .contact-form-container h2 {
    color: #333333;
    font-family: BreeSerif;
    margin-bottom: 20px;
  }

  .form-group {
    margin-bottom: 20px;
    text-align: left;
    padding-left: 10px;
  }

  .form-group input,
  .form-group select,
  .form-group textarea {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .form-group select {
    appearance: none;
    -webkit-appearance: none;
  }

  .form-group textarea {
    resize: vertical;
  }

  .submit-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .form-success {
    color: #1a7a3a;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .form-error {
    color: #842029;
    background-color: #f8d7da;
    border: 1px solid #f5c2c7;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 12px;
    font-size: 0.95rem;
  }

  .submit-button {
    display: inline-block;
    padding: 14px 24px; /* Adjust padding */
    font-size: 16px; /* Adjust font size */
    background-color: #333333;
    color: #fff;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-family: Arial, Helvetica, sans-serif;
    z-index: 1;
    border-radius: 5px; /* Add border-radius */
    transition:
      background-color 0.3s ease,
      color 0.3s ease; /* Add transition */
  }

  .submit-button::before,
  .submit-button::after {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #333333;
    transition: width 0.3s ease; /* Smooth transition animation */
    z-index: -1;
    border-radius: 5px; /* Add border-radius */
  }

  .submit-button::before {
    left: 50%;
    transform: translateX(-50%);
  }

  .submit-button::after {
    right: 50%;
    transform: translateX(50%);
  }

  .submit-button:hover::before {
    width: 0%; /* Shrink the left half of the background color on hover */
  }

  .submit-button:hover::after {
    width: 0%; /* Shrink the right half of the background color on hover */
  }

  .submit-button:hover {
    color: #dc1f26;
    background-color: #dddddd; /* Change background color on hover */
  }

  .bottom-left-textc {
    font-size: 60px;
    margin-top: 0px;
    font-weight: bold;
    font-family: SourceSans;
  }
  .testimonials-section {
    position: relative;
    text-align: center;

    width: 60%;
    margin-left: auto; /* Auto margin from left */
    margin-right: auto; /* Auto margin from right */
  }

  .testimonial {
    padding: 30px 0; /* Increase padding */
  }

  .quote {
    font-style: italic;
    font-size: 1.7rem; /* Increase font size */
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    font-weight: bold;
    font-family: BreeSerif;
  }
  .clients-text {
    color: #333333;
    font-family: BreeSerif;
    font-size: 60px; /* Adjust font size */
    margin-bottom: 20px;
  }

  .author {
    font-size: 1.2rem; /* Increase font size */
    font-family: SourceSans;
    color: #333333;
    margin-bottom: 20px;
    margin-top: 30px;
    text-align: left;
  }

  .arrow-buttons-container {
    margin-left: 20px; /* Add margin between buttons and text */
  }

  .additional-info1 {
    display: flex;
    justify-content: space-between; /* Align items to the edges */
    align-items: center; /* Center vertically */
    margin-top: 1px; /* Adjust as needed */
  }

  .detail1 {
    font-size: 1.2rem;
    text-align: right; /* Align text to the right */
  }
  .arrow-button {
    background: none;
    border: none;
    cursor: pointer;
    color: #054f76;
    font-size: 24px;
    margin: 0 10px; /* Add some space between buttons */
  }

  .arrow-button.left11 {
    margin-right: 20px;
  }

  .arrow-button.right11 {
    margin-left: 20px;
  }

  .additional-info2 {
    display: flex;
    align-items: center;
  }

  /* --------------------------------------------------------------------- */

  .moapp5 {
    text-align: center;
    margin-top: 0px;
    top: 0;
  }

  .title-container {
    margin-bottom: 40px;
  }

  .title {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 2em;
    top: 0;
  }

  .industry-container {
    display: flex;
    justify-content: space-around;
  }

  .industry {
    width: 30%; /* Adjust the width as needed */
  }

  .industry-title {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 1.5em;
  }

  .industry-text {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 1em;
  }
  /* ----------------------------------------- */
  .moapp4 {
    display: flex;
    width: 100%;
    margin-top: 60px;
    height: 80%;
  }

  .leftmo4,
  .rightmo4 {
    width: 50%;
    padding: 20px;
  }

  .leftmo4 {
    text-align: center;
  }

  .partner-image {
    width: 100%;
    height: 100%;
  }

  .rightmo4 {
    text-align: left;
    display: flex; /* Enable flexbox for child elements */
    flex-direction: column; /* Stack elements vertically */
    justify-content: center; /* Center vertically */
    height: 80%;
  }

  .rightmo4 h2 {
    font-family: BreeSerif;
    color: #333333;
    font-size: 55px;
  }

  .main-text {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 1.2em;
    margin: 10px 0;
  }

  .secondary-text {
    font-family: "Bree Serif", serif;
    color: #555555; /* Darker color for the second text */
    font-size: 1em;
  }

  /* -------------------- */
  .moapp1 {
    position: relative;
    text-align: center;
    width: 100%;
    height: 100vh; /* Ensure the container takes full viewport height */
  }

  .background-image {
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensure the image covers the container without stretching */
  }

  .text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-family: "Bree Serif", serif;
    font-size: 65px;
  }
  .moapp2 {
    text-align: center;
    margin-top: 20px;
  }

  .title {
    font-family: BreeSerif;
    color: #333333;
    font-size: 60px;
  }

  .content {
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    margin-top: 20px;
  }

  .section {
    flex: 1;
    margin: 0 10px;
  }

  .section h2 {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 1.5em;
    display: flex;
    align-items: center;
  }

  .section h2 i {
    margin-right: 10px;
  }

  .section p {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 1em;
    margin-top: 10px;
    padding-bottom: 20px;
  }
  .center {
    height: 100%;
  }

  .center img {
    width: 100%;
    height: 100%;
  }

  .center-image {
    height: 100%; /* Adjust the height as needed */
  }

  .moapp3 {
    display: flex;
    width: 100%;
    margin-top: 20px;
  }

  .quarter {
    width: 25%;
    text-align: center;
    padding: 20px;
  }

  .quarter img {
    width: 100%;
    height: auto;
  }

  .large-text {
    font-size: 2em;
    color: #333333;
    font-family: "Bree Serif", serif;
  }

  .quarter h3 {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 1.5em;
    margin: 10px 0;
  }

  .quarter p {
    font-family: "Bree Serif", serif;
    color: #333333;
    font-size: 1em;
  }
  @media (min-width: 1040px) and (max-width: 1324px) {
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }
  }
  @media (min-width: 769px) and (max-width: 1040px) {
    .moapp4 {
      display: flex;
      justify-content: center;
      align-items: flex-start; /* Align items to the top */
      margin-top: 40px;
      margin-bottom: 0px;
      padding-bottom: 0px;
      height: auto;
    }

    .leftmo4,
    .rightmo4 {
      width: 50%;
      padding: 0 10px;
    }

    .partner-image {
      width: 100%;
      max-height: 100%; /* Limit max height to 100% of container height */
      overflow: hidden;
    }

    .rightmo4 {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start; /* Align content to the top */
    }

    .rightmo4 h2 {
      font-size: 24px; /* Adjust font size for the heading */
      margin-bottom: 10px; /* Decrease bottom margin */
      text-align: center;
    }

    .main-text,
    .secondary-text {
      font-size: 16px; /* Adjust font size for text content */
      line-height: 1.5;
      text-align: center;
      overflow: hidden; /* Hide overflow if content exceeds height */
    }

    .secondary-text {
      color: #555555; /* Darker color for the secondary text */
    }
    .title {
      font-size: 48px; /* Adjust font size for the title */
    }

    .content {
      display: flex; /* Align sections horizontally */
      justify-content: space-between; /* Space sections evenly */
      align-items: center; /* Center align items vertically */
      margin-top: 20px;
      flex-wrap: nowrap; /* Prevent wrapping */
    }

    .section {
      flex: 1; /* Evenly distribute space among sections */
      margin: 10px; /* Add margin around sections */
      text-align: center; /* Center text content */
      height: 100%;
    }

    .section.left {
      order: 1; /* Left section on the left */
      text-align: left; /* Left-align text */
    }

    .section.center {
      order: 2; /* Center the image section */
      flex: 0 1 40%; /* Adjust the width for the image section */
      text-align: center; /* Center the image within its section */
    }

    .section.right {
      order: 3; /* Right section on the right */
      text-align: left; /* Right-align text */
    }

    .section h2 {
      font-size: 1.2em; /* Adjust font size for headings */
    }

    .section p {
      font-size: 0.9em; /* Adjust font size for paragraphs */
    }

    .center-image {
      width: 100%; /* Adjust image width */
      height: 100%; /* Maintain aspect ratio */
      display: block; /* Ensure the image is a block element */
      margin: 0 auto; /* Center the image */
    }
    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 50px;
      padding-right: 50px;
    }

    .rightco {
      margin-right: 50px;
      margin-left: 50px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 3rem;
      text-align: center;
    }

    .left-text {
      font-size: 1.1rem;
      text-align: center;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }

    .leftfoo .footer-section h4 {
      font-size: 1.3rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.75rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 15px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
    .moapp1 {
      margin-top: 5%;
      height: auto; /* Change height to auto for smaller screens */
    }

    .text-overlay {
      font-size: 45px; /* Reduce font size for smaller screens */
    }
  }
  @media (min-width: 481px) and (max-width: 769px) {
    /* Adjustments for smaller screens up to 750px */

    /* Container styles */
    .moapp1 {
      margin-top: 12%;
      height: auto; /* Change height to auto for smaller screens */
    }

    .text-overlay {
      font-size: 45px; /* Reduce font size for smaller screens */
    }

    /* Title styles */
    .title {
      font-size: 45px; /* Reduce font size for smaller screens */
    }

    /* Content styles */
    .content {
      display: flex; /* Use flexbox layout */
      flex-direction: row; /* Align sections horizontally */
      flex-wrap: wrap; /* Allow wrapping if needed */
      justify-content: space-between; /* Distribute space between sections */
      align-items: center; /* Center align items vertically */
    }

    /* Section styles */
    .section {
      flex: 1; /* Distribute space evenly */
      margin: 20px 10px; /* Increase margin between sections for smaller screens */
      text-align: center; /* Center text content */
    }

    .section.left,
    .section.right {
      order: 1; /* Ensure text sections are beside each other */
      flex-basis: 45%; /* Set width for left and right sections */
    }

    .section h2 {
      font-size: 1.4em; /* Reduce font size for smaller screens */
    }

    .section p {
      font-size: 1em; /* Reduce font size for smaller screens */
    }

    /* Center image styles */
    .section.center {
      display: none; /* Hide center image on smaller screens */
    }
    .moapp4 {
      margin-left: 0px;
      margin-right: 0px;

      padding-left: 0px;
      padding-right: 0px;
      flex-direction: column;
      align-items: center;
      height: auto;
    }

    .leftmo4,
    .rightmo4 {
      width: 100%;
      padding: 10px;
    }

    .rightmo4 {
      text-align: center;
    }

    .rightmo4 h2 {
      font-size: 1.7em;
    }

    .main-text {
      font-size: 1.1em;
    }

    .secondary-text {
      font-size: 1em;
    }

    /* moapp5 adjustments */
    .industry-container {
      flex-direction: row;
      align-items: center;
    }

    .industry {
      width: 90%;
      margin-bottom: 20px;
    }

    .industry-title {
      font-size: 1.3em;
    }

    .industry-text {
      font-size: 1em;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
    .text-overlay1 h2,
    .text-overlay1 button {
      margin-bottom: 0px;
    }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 0;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
      flex-direction: row;
    }

    .detail-containerfo {
      display: flex;
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%; /* Two items per row */
      box-sizing: border-box;
    }

    .vertical-linefo {
      display: none; /* Hide vertical lines */
    }

    .detailfo:nth-child(1),
    .detailfo:nth-child(2),
    .detailfo:nth-child(3) {
      width: 100%; /* Make the first three items take the full width */
    }

    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay1 button {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
    }
    .text-overlay1 h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }
    .benefits-container,
    .steps {
      flex-direction: column;
      padding-left: 30%;
    }

    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }

    .vertical-linefo {
      display: none; /* Hide vertical line */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
  }

  @media (max-width: 480px) {
    /* Adjustments for smaller screens */

    /* Container styles */
    .moapp1 {
      margin-top: 15%;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      height: auto; /* Change height to auto for smaller screens */
    }

    .text-overlay {
      font-size: 40px; /* Reduce font size for smaller screens */
    }

    /* Title styles */
    .title {
      font-size: 40px; /* Reduce font size for smaller screens */
    }

    /* Content styles */
    .content {
      flex-direction: column; /* Stack sections vertically on smaller screens */
    }

    /* Section styles */
    .section {
      margin: 0px 0; /* Increase margin between sections for smaller screens */
    }

    .section h2 {
      font-size: 1.2em; /* Reduce font size for smaller screens */
    }

    .section p {
      font-size: 0.9em; /* Reduce font size for smaller screens */
    }

    /* Center image styles */
    .center {
      display: none; /* Hide center image on smaller screens */
    }
    .moapp4 {
      flex-direction: column;
      align-items: center;
      height: auto;
      margin-left: 0px;
      margin-right: 0px;
      padding-left: 0px;
      padding-right: 0px;
      margin-top: 0px;
      padding-top: 0px;
    }

    .leftmo4,
    .rightmo4 {
      width: 100%;
      padding: 0px;
    }

    .rightmo4 {
      text-align: center;
    }

    .rightmo4 h2 {
      font-size: 1.5em;
    }

    .main-text {
      font-size: 1em;
    }

    .secondary-text {
      font-size: 0.9em;
    }

    /* moapp5 adjustments */
    .industry-container {
      flex-direction: column;
      align-items: center;
    }

    .industry {
      width: 90%;
      margin-bottom: 20px;
    }

    .industry-title {
      font-size: 1.2em;
    }

    .industry-text {
      font-size: 0.9em;
    }
    .footer {
      display: block; /* Stack footer sections */
      padding: 10px; /* Adjust padding */
    }

    .footer-content {
      flex-direction: column; /* Stack footer sections vertically */
    }

    .leftfoo,
    .rightfo {
      width: 100%; /* Take full width */
    }
    .text-overlay1 h2,
    .text-overlay1 button {
      margin-bottom: 0px;
    }
    .leftfoo .footer-section h4 {
      font-size: 1.2rem; /* Adjust font size */
      margin-top: 20px; /* Adjust margin */
    }

    .leftfoo .footer-section input[type="email"] {
      margin-top: 20px;
      padding: 10px; /* Adjust padding */
      width: calc(100% - 20px); /* Adjust width */
    }

    .leftfoo .footer-section label {
      padding-right: 20px; /* Adjust padding */
      font-size: 0.7rem; /* Adjust font size */
    }

    .leftfoo .footer-section button {
      margin-left: 30px;
      margin-top: 20px; /* Adjust margins */
      padding: 10px 20px; /* Adjust padding */
      font-size: 14px; /* Adjust font size */
    }

    .hofo {
      padding: 10px; /* Adjust padding */
    }

    .detail-containerfo {
      flex-wrap: wrap;
    }

    .detailfo {
      width: 50%;
      box-sizing: border-box;
    }

    .detailfo:nth-child(3) {
      width: 100%; /* Full width for the address section */
      padding: 10px 0; /* Add some padding for the address section */
    }

    .vertical-linefo {
      display: none;
    }
    .center-textfooo {
      font-size: 0.8rem; /* Adjust font size */
    }
    .rightfo button {
      padding: 8px 8px; /* Adjust padding for smaller screens */
      font-size: 14px; /* Reduce font size for smaller screens */
    }
    .rightfo h2 img {
      transform: scale(1); /* Adjust the scale of the image */
    }

    .text-overlay1 button {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
    }
    .text-overlay1 h2 {
      margin-top: 0; /* Adjust margin to remove distance */
      margin-bottom: 0; /* Adjust margin to remove distance */
      padding-bottom: 0px;
    }

    .cont {
      flex-direction: column;
    }

    .leftco {
      padding-left: 20px;
      padding-right: 20px;
    }

    .rightco {
      margin-right: 20px;
      margin-left: 20px;
      flex: 100%;
    }

    .benefits-container,
    .steps {
      flex-direction: column;
      width: 50%;
      margin-left: auto;
      margin-right: auto;
    }
    .bottom-left-textc {
      font-size: 2rem;
      text-align: center;
    }

    .left-text {
      font-size: 1rem;
      text-align: center;
    }

    .vertical-linefo {
      display: none; /* Hide vertical line */
    }

    .center-textfooo {
      font-size: 0.9rem; /* Adjust font size */
    }
  }
</style>
